import React, {Component} from "react"
import {Button, Container, Divider, Form, Header, Message, Segment} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {isEmailValid, resolveErrorMessage} from "../utils/common";
import {getLocalization} from "../utils/localization";
import {setResetTokenEmail} from "../actions/userActions";
import Footer from "./footer";
import {CustomEmailInput, CustomGrid} from "./custom-common";
import {resetToken} from "../services/services";
import {ResetTokenRequest} from "../services/types";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData} = state;
    return {
        ...ownProps,
        lang: user.lang,
        token: initialData.token,
    }
};

class ExpiredToken extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: false,
            email: null,
            message: null,
        };
    }

    componentDidMount() {
        window.onbeforeunload = null;
    }

    resetToken = async (email) => {
        this.setState({loading: true});
        const {token, lang, dispatch, history} = this.props;
        const localization = getLocalization(lang);
        const strings = localization.expiredToken;

        const handleError = (message) => {
            this.setState({
                loading: false,
                error: true,
                message
            });
        }

        try {
            const request = new ResetTokenRequest({email, token});
            let result = await resetToken(request);
            if (result.status === 200) {
                dispatch(setResetTokenEmail(email));
                this.setState({loading: false});
                window.onbeforeunload = null;
                history.push("/requestSent");
            } else {
                handleError(strings.error);
            }
        } catch (e) {
            handleError(resolveErrorMessage(e, strings.error));
        }
    }

    handleSubmit = async () => {
        this.setState({error: false});
        const {email} = this.state;
        await this.resetToken(email);
    }

    render() {
        const {email, error, loading, message} = this.state;
        const localization = getLocalization(this.props.lang);
        const strings = localization.expiredToken;
        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <CustomGrid container stackable centered>
                        <CustomGrid.Column style={{marginTop: '3em'}} width={5}>
                            <Header as={"h2"} textAlign={"center"}>{strings.title}</Header>
                            <Segment padded>
                                <p className={"small"}>{strings.descr}</p>
                                <Form>
                                    <CustomEmailInput
                                        name='email'
                                        value={email || ''}
                                        onChange={(e, {value}) => {
                                            this.setState({email: value});
                                        }}
                                        required
                                    />
                                    <Button primary
                                            loading={loading}
                                            onClick={this.handleSubmit}
                                            disabled={!email || !isEmailValid(email) || loading}>
                                        {strings.sendLink}
                                    </Button>
                                    {error && <Message negative>{message}</Message>}
                                    <Divider hidden/>
                                </Form>
                            </Segment>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer hideLimitationsAndExclusions={true}/>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(ExpiredToken));
